import standardAPI from '@/api/standard_items';

const state = {
  holidays: [],
  holidays_status: '',
  holidays_MetaData: {},
  holidays_page: 1,
  holidays_perPage: 10,
};

const responseUrl = '/organisation-tours/holidays';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_holidays ({ commit }, getOptions) {
    commit('HOLIDAYS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('HOLIDAYS_SUCCESS', response);
            commit('HOLIDAYS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('HOLIDAYS_READY');
            reject(response);
          } else {
            commit('HOLIDAYS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_holiday ({ commit, dispatch }, itemData) {
    commit('HOLIDAYS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('HOLIDAYS_READY');
          reject(response);
        }
      });
    });
  },
  edit_holiday ({ commit, dispatch }, itemData) {
    commit('HOLIDAYS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('HOLIDAYS_READY');
          reject(response);
        }
      });
    });
  },
  remove_holiday ({ commit, dispatch }, itemData) {
    commit('HOLIDAYS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('HOLIDAYS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_holiday ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_holiday_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.holidays_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.holidays_perPage = max;
  },
  HOLIDAYS_READY: (state) => {
    state.holidays_status = 'ready';
  },
  HOLIDAYS_REQUEST: (state) => {
    state.holidays_status = 'loading';
  },
  HOLIDAYS_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.holidays_MetaData.meta = response.meta;
      state.holidays_MetaData.links = response.links;
    }
    state.holidays = response.data;
    state.holidays_status = 'success';
  },
  HOLIDAYS_ERROR: (state) => {
    state.holidays_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
